import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

import baPost from "../Images/Ba post.jpg";
import bahoz from "../Images/Bahoz.jpg";
import bardawamPlus from "../Images/Bardawam plus.jpg";
import drBardawam from "../Images/Dr bardawam.jpg";
import fomsi from "../Images/Fomsi.jpg";
import rebazCars from "../Images/Rebaz Cars.jpg";
import samHome from "../Images/Sam home.jpg";
import sinolo from "../Images/Sinolo.jpg";
import suliShop from "../Images/suli shop.png";
import talabati from "../Images/talabati.jpg";
import ukToMars from "../Images/Uk to mars.jpg";
import kts4u from "../Images/KTS4U.jpg";
import rainSeason from "../Images/Rain season.jpg";
import salvanoGroup from "../Images/Salvano group.jpg";
import crystalBardawam from "../Images/crstyl Bardawam.jpg";
import restaurantMenu from "../Images/restaurant menu.jpg";
import noon from "../Images/Noon.jpg";
import karwanCompany from "../Images/Karwan company.jpg";
import cleverSchool from "../Images/Clever school.jpg";
import warehouseSystem from "../Images/warehouse system.png";

const groups = [
  {
    titleKey: "Applications",
    items: [
      { name: "SinoLo", image: sinolo, page: "/sinolo" },
      { name: "Ba Post", image: baPost, page: "/ba-post" },
      { name: "Fomsi", image: fomsi, page: "/fomsi" },
      { name: "Dr Bardawam", image: drBardawam, page: "/bardawam" },
      { name: "Suli Shop", image: suliShop },
      { name: "Bardawam Plus", image: bardawamPlus, page: "/bardawam-plus" },
      { name: "Bahoz", image: bahoz, page: "/bahoz" },
      { name: "Talab Delivery", image: talabati, page: "/talab-delivery" },
      { name: "Rebaz Cars", image: rebazCars, page: "/rebaz-cars" },
      { name: "Sam Home", image: samHome, page: "/sam-home" },
    ],
  },
  {
    titleKey: "Websites",
    items: [
      { name: "UK to Mars", image: ukToMars, page: "/uk-to-mars" },
      { name: "KTS4U", image: kts4u, page: "/kts4u" },
      { name: "Bardawam", image: drBardawam, page: "/bardawam" },
      { name: "Crystal Bardawam", image: crystalBardawam, page: "/bardawam" },
      { name: "Rain Season", image: rainSeason, page: "/rain-season" },
      {
        name: "Restaurant Menu",
        image: restaurantMenu,
        page: "/restaurant-menu",
      },
      { name: "Noon", image: noon, page: "/noon" },
      { name: "Salvano Group", image: salvanoGroup, page: "/salvano-group" },
      { name: "Karwan Company", image: karwanCompany, page: "/karwan-company" },
    ],
  },
  {
    titleKey: "Systems",
    items: [
      { name: "Clever School", image: cleverSchool, page: "/clever-school" },
      { name: "Warehouse System", image: warehouseSystem, page: "/warehouse" },
    ],
  },
];

const sliderLogos = groups
  .flatMap((group) => group.items)
  .filter(
    (item, index, list) =>
      list.findIndex((logo) => logo.name === item.name) === index,
  );

export function LogoSlider() {
  const track = [...sliderLogos, ...sliderLogos];

  return (
    <Box className="logo-slider" aria-hidden="true">
      <Box className="logo-slider-track">
        {track.map((item, index) => (
          <Box className="logo-slider-item" key={`${item.name}-${index}`}>
            <Box component="img" src={item.image} alt="" />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

const storyTextSx = (isRtl) => ({
  fontFamily: isRtl
    ? '"NRT-Reg", "Rabar", sans-serif !important'
    : '"Rabar", sans-serif !important',
  color: "rgba(255,255,255,0.82) !important",
});

const linkCardSx = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1,
  p: { xs: 2, md: 2.5 },
  borderRadius: 3,
  textDecoration: "none",
  textAlign: "center",
  color: "#ffffff",
  background: "rgba(4, 16, 32, 0.55)",
  border: "1px solid rgba(126, 232, 255, 0.22)",
  transition: "transform 0.25s ease, border-color 0.25s ease",
  "&:hover": {
    transform: "translateY(-4px)",
    borderColor: "#7ee8ff",
  },
};

function ProjectStory({
  images,
  title,
  paragraphs = [],
  highlights,
  links = [],
  details,
  sections,
  notes,
  closing,
  maxWidth = "md",
}) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRtl = ["ku", "ar"].includes(i18n.language);
  const textSx = storyTextSx(isRtl);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    navigate("/");
    const behavior = window.matchMedia("(pointer: coarse)").matches
      ? "auto"
      : "smooth";
    let attempts = 0;
    const scroll = () => {
      const element = document.getElementById("WhatWeBuilt");
      if (element) {
        element.scrollIntoView({ behavior, block: "start" });
        return;
      }
      if (attempts > 30) return;
      attempts += 1;
      requestAnimationFrame(scroll);
    };
    requestAnimationFrame(scroll);
  };

  return (
    <Container
      maxWidth={maxWidth}
      dir={isRtl ? "rtl" : "ltr"}
      sx={{
        pt: { xs: 14, md: 16 },
        pb: { xs: 6, md: 10 },
      }}
    >
      <Button
        onClick={goBack}
        sx={{
          mb: 3,
          color: "#ffffff",
          textTransform: "none",
          fontWeight: 700,
          borderRadius: "999px",
          border: "1px solid rgba(255,255,255,0.28)",
          px: 2.5,
          "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
        }}
      >
        {t("Back")}
      </Button>

      <Box
        sx={{
          px: { xs: 2.5, md: 6 },
          py: { xs: 4, md: 6 },
          borderRadius: 4,
          textAlign: "center",
          background: "rgba(4, 16, 32, 0.5)",
          border: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(16px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 3,
          }}
        >
          {images.map((image) => (
            <Box
              key={image.alt}
              component="img"
              src={image.src}
              alt={image.alt}
              sx={{
                width: 132,
                height: 132,
                objectFit: "cover",
                borderRadius: "28px",
                boxShadow: "0 12px 28px rgba(0,0,0,0.35)",
              }}
            />
          ))}
        </Box>

        <Typography
          sx={{
            ...textSx,
            fontSize: { xs: "1.25rem", md: "1.7rem" },
            fontWeight: 800,
            lineHeight: 1.9,
            color: "#ffffff !important",
            mb: 2,
          }}
        >
          {title}
        </Typography>
        {paragraphs.map((paragraph) => (
          <Typography
            key={paragraph}
            sx={{
              ...textSx,
              maxWidth: 680,
              mx: "auto",
              fontSize: { xs: "1rem", md: "1.15rem" },
              lineHeight: 2.1,
              mb: 2,
            }}
          >
            {paragraph}
          </Typography>
        ))}
        {highlights?.map((line) => (
          <Typography
            key={line}
            sx={{
              ...textSx,
              fontWeight: 800,
              fontSize: { xs: "1.05rem", md: "1.2rem" },
              color: "#ffffff !important",
              lineHeight: 1.8,
            }}
          >
            {line}
          </Typography>
        ))}

        {links.length > 0 && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns:
                links.length === 1 ? "1fr" : { xs: "1fr", sm: "1fr 1fr" },
              maxWidth: links.length === 1 ? 460 : "none",
              mx: links.length === 1 ? "auto" : 0,
              gap: 2,
              mt: { xs: 3, md: 4 },
            }}
          >
            {links.map((store) => (
              <Box
                key={store.href}
                component="a"
                href={store.href}
                target="_blank"
                rel="noopener noreferrer"
                sx={linkCardSx}
              >
                <Typography
                  sx={{
                    ...textSx,
                    fontWeight: 700,
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    color: "#ffffff !important",
                    lineHeight: 1.8,
                  }}
                >
                  {store.label}
                </Typography>
                <Typography sx={{ color: "#ffffff !important" }}>👇</Typography>
                <Typography
                  dir="ltr"
                  sx={{
                    color: "#7ee8ff !important",
                    fontSize: { xs: "0.78rem", md: "0.85rem" },
                    lineHeight: 1.6,
                    wordBreak: "break-all",
                  }}
                >
                  {store.href}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
        {details && (
          <Box sx={{ mt: { xs: 3, md: 4 } }}>
            <Typography
              sx={{
                ...textSx,
                fontWeight: 800,
                fontSize: { xs: "1.05rem", md: "1.2rem" },
                color: "#ffffff !important",
                lineHeight: 1.8,
                mb: 1,
              }}
            >
              {details.title}
            </Typography>
            {details.items.map((line) => (
              <Typography
                key={line}
                sx={{
                  ...textSx,
                  fontWeight: 700,
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  color: "#ffffff !important",
                  lineHeight: 1.9,
                }}
              >
                {line}
              </Typography>
            ))}
          </Box>
        )}
        {sections?.map((section) => (
          <Box
            key={section.title || section.items[0]}
            sx={{ mt: { xs: 3, md: 4 } }}
          >
            {section.title && (
              <Typography
                sx={{
                  ...textSx,
                  fontWeight: 800,
                  fontSize: { xs: "1.05rem", md: "1.2rem" },
                  color: "#ffffff !important",
                  lineHeight: 1.8,
                  mb: 1,
                }}
              >
                {section.title}
              </Typography>
            )}
            {section.items.map((line) => (
              <Typography
                key={line}
                sx={{
                  ...textSx,
                  maxWidth: 760,
                  mx: "auto",
                  fontSize: { xs: "0.98rem", md: "1.08rem" },
                  lineHeight: 2,
                  mb: 1.25,
                }}
              >
                {line}
              </Typography>
            ))}
          </Box>
        ))}
        {notes?.map((line) => (
          <Typography
            key={line}
            sx={{
              ...textSx,
              maxWidth: 760,
              mx: "auto",
              mt: 2,
              fontSize: { xs: "1rem", md: "1.12rem" },
              lineHeight: 2.1,
              color: "#ffffff !important",
            }}
          >
            {line}
          </Typography>
        ))}
        {closing && (
          <Typography
            sx={{
              ...textSx,
              maxWidth: 680,
              mx: "auto",
              mt: { xs: 3, md: 4 },
              fontSize: { xs: "1rem", md: "1.15rem" },
              lineHeight: 2.1,
            }}
          >
            {closing}
          </Typography>
        )}
      </Box>
    </Container>
  );
}

export function FomsiPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: fomsi, alt: "Fomsi" }]}
      title={t("Fomsi story title")}
      paragraphs={[t("Fomsi story body")]}
      links={[
        {
          label: t("Application link for Android"),
          href: "https://play.google.com/store/apps/details?id=com.fomsi.customers",
        },
        {
          label: t("Application link for iOS"),
          href: "https://apps.apple.com/app/id6783715936",
        },
      ]}
    />
  );
}

export function BardawamPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[
        { src: drBardawam, alt: "Dr Bardawam" },
        { src: crystalBardawam, alt: "Crystal Bardawam" },
      ]}
      title={t("Bardawam story title")}
      paragraphs={[t("Bardawam story intro"), t("Bardawam story parts")]}
      highlights={[t("Dr Bardawam part"), t("Crystal Bardawam part")]}
      links={[
        {
          label: t("Bardawam Android link"),
          href: "https://play.google.com/store/apps/details?id=com.drbardawam.customers",
        },
        {
          label: t("Bardawam iOS link"),
          href: "https://apps.apple.com/ar/app/dr-bardawam/id6783860943",
        },
        {
          label: t("Dr Bardawam website link"),
          href: "https://dr-bardawam.com",
        },
        {
          label: t("Crystal Bardawam website link"),
          href: "https://crystal.dr-bardawam.com",
        },
      ]}
      closing={t("Bardawam story closing")}
    />
  );
}

export function UkToMarsPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: ukToMars, alt: "UK to Mars" }]}
      title={t("UK to Mars story title")}
      paragraphs={[t("UK to Mars story body")]}
      links={[
        {
          label: t("UK to Mars website link"),
          href: "https://uktomars.co.uk/",
        },
      ]}
      closing={t("UK to Mars story closing")}
    />
  );
}

export function BaPostPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: baPost, alt: "Ba Post" }]}
      title={t("Ba Post story title")}
      paragraphs={[t("Ba Post story body")]}
      links={[
        {
          label: t("Ba Post Android link"),
          href: "https://play.google.com/store/apps/details?id=com.bapost.customer",
        },
        {
          label: t("Ba Post iOS link"),
          href: "https://apps.apple.com/us/app/bapost/id6763597867",
        },
      ]}
      details={{
        title: t("Ba Post parts title"),
        items: [
          t("Ba Post admin app"),
          t("Ba Post admin website"),
          t("Ba Post user app"),
          t("Ba Post store app"),
          t("Ba Post rider app"),
        ],
      }}
      closing={t("Ba Post story closing")}
    />
  );
}

export function Kts4uPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: kts4u, alt: "KTS4U" }]}
      title={t("KTS4U story title")}
      paragraphs={[]}
      links={[
        {
          label: t("KTS4U website link"),
          href: "https://kurdishtranslationservices4u.co.uk/",
        },
      ]}
      closing={t("KTS4U story closing")}
    />
  );
}

export function CleverSchoolPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      maxWidth="lg"
      images={[{ src: cleverSchool, alt: "Clever School" }]}
      title={t("Clever School title")}
      paragraphs={[t("Clever School intro"), t("Clever School services")]}
      highlights={[t("Clever School users"), t("Clever School branches")]}
      sections={[
        {
          items: [
            t("Clever School users entry"),
            t("Clever School students"),
            t("Clever School teachers"),
            t("Clever School expenses"),
          ],
        },
        {
          title: t("Clever School sales"),
          items: [t("Clever School uniforms"), t("Clever School books")],
        },
        {
          title: t("Clever School reports"),
          items: [
            t("Clever School report one"),
            t("Clever School report all"),
            t("Clever School report discount"),
            t("Clever School report unpaid"),
            t("Clever School report expenses month"),
            t("Clever School report expenses year"),
            t("Clever School report teachers month"),
            t("Clever School report teachers year"),
          ],
        },
      ]}
      notes={[
        t("Clever School languages"),
        t("Clever School design"),
        t("Clever School security"),
        t("Clever School one system"),
        t("Clever School guarantee"),
        t("Clever School extra"),
      ]}
    />
  );
}

export function WarehousePage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      maxWidth="lg"
      images={[{ src: warehouseSystem, alt: "Warehouse System" }]}
      title={t("Warehouse title")}
      paragraphs={[t("Clever School intro"), t("Warehouse services")]}
      sections={[
        {
          items: [
            t("Warehouse products"),
            t("Warehouse filter"),
            t("Warehouse quantity"),
            t("Warehouse units"),
            t("Warehouse sales"),
            t("Warehouse customers"),
            t("Warehouse balance"),
            t("Warehouse print"),
            t("Warehouse reports"),
            t("Warehouse languages"),
          ],
        },
      ]}
      notes={[t("Clever School guarantee"), t("Clever School extra")]}
    />
  );
}

export function BahozPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: bahoz, alt: "Bahoz" }]}
      title={t("Bahoz story title")}
      paragraphs={[t("Bahoz story body")]}
      links={[
        {
          label: t("Bahoz Android link"),
          href: "https://play.google.com/store/apps/details?id=com.baranweb.UserApp",
        },
        {
          label: t("Bahoz iOS link"),
          href: "https://apps.apple.com/us/app/bahoz/id6747296541",
        },
      ]}
      details={{
        title: t("Bahoz parts title"),
        items: [
          t("Ba Post admin website"),
          t("Ba Post user app"),
          t("Ba Post store app"),
          t("Ba Post rider app"),
        ],
      }}
      notes={[t("Bahoz story features"), t("Bahoz story continue")]}
    />
  );
}

export function BardawamPlusPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: bardawamPlus, alt: "Bardawam Plus" }]}
      title={t("Bardawam Plus story title")}
      paragraphs={[t("Bardawam Plus parts title")]}
      highlights={[
        t("Bardawam Plus user site"),
        t("Bardawam Plus admin site"),
        t("Bardawam Plus stores site"),
      ]}
      links={[
        {
          label: t("Bardawam Plus website link"),
          href: "https://www.bardawamplus.com/",
        },
      ]}
    />
  );
}

export function RainSeasonPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: rainSeason, alt: "Rain Season" }]}
      title={t("Rain Season story title")}
      paragraphs={[t("Rain Season story body")]}
    />
  );
}

export function TalabDeliveryPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      maxWidth="lg"
      images={[{ src: talabati, alt: "Talab Delivery" }]}
      title={t("Talab story title")}
      links={[
        {
          label: t("Talab Android link"),
          href: "https://play.google.com/store/apps/details?id=com.smartsolutions.talabdelivery",
        },
        {
          label: t("Talab iOS link"),
          href: "https://apps.apple.com/iq/app/iraq-delivery/id6464159132",
        },
      ]}
      sections={[
        {
          items: [
            t("Talab restaurants"),
            t("Talab languages"),
            t("Talab add restaurants"),
            t("Talab menu"),
            t("Talab cities"),
            t("Talab social account"),
            t("Talab easy account"),
            t("Talab categories"),
            t("Talab accounting"),
          ],
        },
      ]}
    />
  );
}

export function RebazCarsPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: rebazCars, alt: "Rebaz Cars" }]}
      title={t("Rebaz Cars story title")}
      highlights={[t("Rebaz Cars app parts"), t("Rebaz Cars website parts")]}
    />
  );
}

export function SamHomePage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: samHome, alt: "Sam Home" }]}
      title={t("Sam Home story title")}
      paragraphs={[t("Sam Home parts title")]}
      highlights={[
        t("Sam Home user app"),
        t("Sam Home seller app"),
        t("Sam Home super admin app"),
        t("Sam Home seller website"),
      ]}
    />
  );
}

export function RestaurantMenuPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      maxWidth="lg"
      images={[{ src: restaurantMenu, alt: "Restaurant Menu" }]}
      title={t("Restaurant Menu story title")}
      paragraphs={[t("Restaurant Menu parts title")]}
      highlights={[
        t("Restaurant Menu websites"),
        t("Restaurant Menu category"),
        t("Restaurant Menu languages"),
        t("Restaurant Menu active"),
        t("Restaurant Menu manage"),
        t("Restaurant Menu mode"),
        t("Restaurant Menu more"),
      ]}
      notes={[t("Restaurant Menu changes")]}
    />
  );
}

export function KarwanCompanyPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: karwanCompany, alt: "Karwan Company" }]}
      title={t("Karwan Company story title")}
      paragraphs={[t("Karwan Company story body")]}
    />
  );
}

export function SalvanoGroupPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: salvanoGroup, alt: "Salvano Group" }]}
      title={t("Salvano Group story title")}
    />
  );
}

export function NoonPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: noon, alt: "Noon" }]}
      title={t("Noon story title")}
      paragraphs={[t("Noon story body")]}
    />
  );
}

export function SinoLoPage() {
  const { t } = useTranslation();

  return (
    <ProjectStory
      images={[{ src: sinolo, alt: "SinoLo" }]}
      title={t("SinoLo story title")}
      links={[
        {
          label: t("SinoLo website link"),
          href: "https://sinolo.app",
        },
      ]}
      notes={[t("SinoLo story connect"), t("SinoLo story china")]}
    />
  );
}

function WorkShowcase() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState(groups[0].titleKey);
  const activeGroup = groups.find((group) => group.titleKey === activeKey);

  return (
    <section
      id="WhatWeBuilt"
      style={{ padding: "64px 0 48px", scrollMarginTop: 96 }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          fontWeight={600}
          color="primary"
          sx={{
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
            mb: { xs: 3, md: 4 },
          }}
        >
          {t("What We Have Built")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: { xs: 1, md: 1.5 },
            justifyContent: "center",
            mb: { xs: 3, md: 5 },
          }}
        >
          {groups.map((group) => {
            const isActive = group.titleKey === activeKey;
            return (
              <Button
                key={group.titleKey}
                onClick={() => setActiveKey(group.titleKey)}
                sx={{
                  flex: "1 1 0",
                  maxWidth: 240,
                  minWidth: 0,
                  px: { xs: 1, md: 2.5 },
                  py: { xs: 1, md: 1.15 },
                  borderRadius: "999px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: { xs: "0.78rem", sm: "0.95rem", md: "1rem" },
                  whiteSpace: "nowrap",
                  color: isActive ? "#041018" : "#ffffff",
                  background: isActive
                    ? "linear-gradient(90deg, #7ee8ff 0%, #42a5f5 100%)"
                    : "rgba(4, 16, 32, 0.42)",
                  border: "1px solid rgba(255,255,255,0.16)",
                  boxShadow: isActive
                    ? "0 6px 16px rgba(66,165,245,0.35)"
                    : "none",
                  "&:hover": {
                    color: isActive ? "#041018" : "#ffffff",
                    background: isActive
                      ? "linear-gradient(90deg, #b6f3ff 0%, #64b5f6 100%)"
                      : "rgba(255,255,255,0.1)",
                  },
                }}
              >
                {t(group.titleKey)}
              </Button>
            );
          })}
        </Box>

        <Grid container spacing={{ xs: 2, md: 3 }} justifyContent="center">
          {activeGroup.items.map((item) => {
            const openPage = item.page
              ? () => {
                  navigate(item.page);
                  window.scrollTo(0, 0);
                }
              : undefined;
            return (
              <Grid item xs={6} sm={4} md={3} key={`${activeKey}-${item.name}`}>
                <Box
                  onClick={openPage}
                  role={openPage ? "button" : undefined}
                  tabIndex={openPage ? 0 : undefined}
                  onKeyDown={
                    openPage
                      ? (event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            openPage();
                          }
                        }
                      : undefined
                  }
                  sx={{
                    height: "100%",
                    p: 1,
                    textAlign: "center",
                    cursor: openPage ? "pointer" : "default",
                    borderRadius: 2,
                    transition: "transform 0.25s ease",
                    "&:hover": openPage
                      ? { transform: "translateY(-4px)" }
                      : undefined,
                  }}
                >
                  <Box
                    sx={{
                      height: 140,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 1.5,
                    }}
                  >
                    <Box
                      component="img"
                      src={item.image}
                      alt={item.name}
                      sx={{
                        width: 112,
                        height: 112,
                        objectFit: "cover",
                        borderRadius: "24px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.28)",
                      }}
                    />
                  </Box>
                  <Typography sx={{ fontWeight: 700, color: "#ffffff" }}>
                    {item.name}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </section>
  );
}

export default WorkShowcase;
